"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initAdapters = initAdapters;
exports.selectAdapter = selectAdapter;
exports.getSelectedAdapter = getSelectedAdapter;
exports.getWalletAdapters = getWalletAdapters;
exports.getAdaptersByReadyState = getAdaptersByReadyState;
exports.sortWalletAdapters = sortWalletAdapters;
exports.addWalletAdapterEventListeners = addWalletAdapterEventListeners;
var index_1 = require("../types/index");
var wallet_standard_base_1 = require("@hermis/wallet-standard-base");
// Store for all initialized adapters
var _adapters = [];
var _selectedAdapter = null;
/**
 * Initialize wallet adapters
 * @param adapters Array of wallet adapters to initialize
 */
function initAdapters(adapters) {
    // Initialize wallet detection system
    (0, wallet_standard_base_1.initializeWalletDetection)();
    // Merge provided adapters with any detected standard wallets
    var allAdapters = (0, wallet_standard_base_1.getDetectedWalletAdapters)(adapters);
    // Filter out any unsupported adapters and assign to the store
    _adapters = allAdapters.filter(function (adapter) { return adapter.readyState !== index_1.WalletReadyState.Unsupported; });
}
/**
 * Select a wallet adapter by name
 * @param walletName Name of the wallet to select
 * @returns The selected adapter or null if not found
 */
function selectAdapter(walletName) {
    if (!walletName) {
        _selectedAdapter = null;
        return null;
    }
    var adapter = _adapters.find(function (adapter) { return adapter.name === walletName; }) || null;
    _selectedAdapter = adapter;
    return adapter;
}
/**
 * Get the currently selected adapter
 * @returns The currently selected adapter or null
 */
function getSelectedAdapter() {
    return _selectedAdapter;
}
/**
 * Get all wallet adapters, optionally filtered by ready state
 * @param readyState Optional wallet ready state to filter by
 * @returns Array of wallet providers
 */
function getWalletAdapters(readyState) {
    var adapters = _adapters;
    if (readyState) {
        adapters = adapters.filter(function (adapter) { return adapter.readyState === readyState; });
    }
    return adapters.map(function (adapter) { return ({
        adapter: adapter,
        name: adapter.name,
        icon: adapter.icon,
        url: adapter.url,
        readyState: adapter.readyState
    }); });
}
// Import utility functions from utils to avoid code duplication
var adapter_utils_1 = require("../utils/adapter-utils");
/**
 * Get wallet adapters by ready state
 * @param adapters Array of adapters
 * @param readyState The ready state to filter by
 * @returns Filtered array of adapters
 */
function getAdaptersByReadyState(adapters, readyState) {
    return (0, adapter_utils_1.getAdaptersByReadyState)(adapters, readyState);
}
/**
 * Sort wallet adapters by priority (Mobile > Installed > Loadable > others)
 * @param adapters Array of wallet adapters
 * @returns Sorted array of wallet adapters
 */
function sortWalletAdapters(adapters) {
    return (0, adapter_utils_1.sortWalletAdapters)(adapters);
}
/**
 * Handler for wallet adapter events
 * @param adapter The wallet adapter to listen to
 * @param handlers Object with event handlers
 * @returns Function to remove the event listeners
 */
function addWalletAdapterEventListeners(adapter, handlers) {
    var onConnect = handlers.onConnect, onDisconnect = handlers.onDisconnect, onError = handlers.onError, onReadyStateChange = handlers.onReadyStateChange;
    if (onConnect) {
        adapter.on('connect', onConnect);
    }
    if (onDisconnect) {
        adapter.on('disconnect', onDisconnect);
    }
    if (onError) {
        adapter.on('error', onError);
    }
    if (onReadyStateChange) {
        adapter.on('readyStateChange', onReadyStateChange);
    }
    // Return function to remove all event listeners
    return function () {
        if (onConnect) {
            adapter.off('connect', onConnect);
        }
        if (onDisconnect) {
            adapter.off('disconnect', onDisconnect);
        }
        if (onError) {
            adapter.off('error', onError);
        }
        if (onReadyStateChange) {
            adapter.off('readyStateChange', onReadyStateChange);
        }
    };
}
